import { useEffect } from 'react';
import { useBGM } from '../../hooks/useBGM';

interface AutoBGMProps {
  bgmSrc: string;
  volume?: number;
  autoPlay?: boolean;
}

const AutoBGM = ({ 
  bgmSrc, 
  volume = 0.3, 
  autoPlay = true 
}: AutoBGMProps) => {
  const { play } = useBGM({
    src: bgmSrc,
    volume,
    loop: true,
  });

  useEffect(() => {
    if (autoPlay) {
      // 사용자 상호작용 후 자동 재생
      const handleUserInteraction = () => {
        play();
        document.removeEventListener('click', handleUserInteraction);
        document.removeEventListener('touchstart', handleUserInteraction);
        document.removeEventListener('keydown', handleUserInteraction);
      };

      document.addEventListener('click', handleUserInteraction);
      document.addEventListener('touchstart', handleUserInteraction);
      document.addEventListener('keydown', handleUserInteraction);

      return () => {
        document.removeEventListener('click', handleUserInteraction);
        document.removeEventListener('touchstart', handleUserInteraction);
        document.removeEventListener('keydown', handleUserInteraction);
      };
    }
  }, [autoPlay, play]);

  // UI는 렌더링하지 않음 (배경음만 재생)
  return null;
};

export default AutoBGM;
